import Link from 'next/link';
import { IAuhtor } from '@/api/detail';
import { useTranslations } from 'next-intl';
import CommonImage from '../CommonImage';
import CommonEquipment from '../CommonEquipment';
import CommonIcon from '../CommonIcon';
import { getDetailUrl, getUserHomeUrl } from '@/constants/url';
import Styles from './index.module.scss';
import namespace from '@/context/namespace';
import { StoreContext } from '@/context';
import { useContext } from 'react';
import { ThreadDetailCtx } from '@/context/threadDetail';
import { decodeSubjectText } from '@/utils/html';

interface IThreadUser {
  author: IAuhtor;
}

const ThreadUser = ({
  author,
}: IThreadUser) => {
  const t = useTranslations();


  const { state } = useContext(StoreContext);
  const threadDetail = useContext(ThreadDetailCtx);
  const { track, TRACK_EVENTS, extractThreadTags } = state[namespace.app].sensors || {};

  const userProfileEntryClick = () => {

    //通过关于作者进入用户主页埋点
    track?.(TRACK_EVENTS?.[namespace.detail].userProfileEntryClick.name, {
      thread_tid: threadDetail?.tid,
      thread_name: threadDetail?.subject,
      account_slug: threadDetail?.author?.id,
      list_name: (threadDetail?.forum_types || [])[0]?.name || t('btn_home'),
      position: 'AuthorTop',
    }, namespace.detail);
  }

  const moreHref = author?.threads?.length > 0 ? getUserHomeUrl(author.id, author.uuid) : process.env.SITE_ORIGIN as string;

  return (
    <div className={Styles.root}>
      <div className={Styles.userTitle}>
        <h3 className={Styles.title}>{t("thread_author_title")}</h3>
        {!author?.hide_distance && author?.total_distance > 0 && <p>{t("thread_total_distance", {"distance": author?.total_distance})}</p>}
      </div>
      <div className={Styles.userIntro}>
        <Link
          target='_blank'
          href={getUserHomeUrl(author.id, author.uuid)}
          onClick={() => {
            userProfileEntryClick();
          }}
        >
          <CommonImage
            src={author.avatar}
            className={Styles.avatar}
            cutMode="fill"
          />
        </Link>
        <div className={Styles.right}>
          <Link
            target='_blank'
            href={getUserHomeUrl(author.id, author.uuid)}
            onClick={() => {
              userProfileEntryClick();
            }}
          >
            <p className={Styles.nickname}>{author.name}</p>
          </Link>
          <div className={Styles.level}>{author.group.title}</div>
        </div>
      </div>
      <div className={Styles.equipments}>
        <p className={Styles.title}>{t("thread_authenticated_device")}</p>
        {
          author?.devices?.length > 0 ?
          <ul className={Styles.equipmentList}>
            {
              author.devices.map(device=>{
                return (<li key={device.key} onClick={() => {
                    // 产品入口埋点
                    track?.(TRACK_EVENTS?.[namespace.detail].productEntryClick.name, {
                      list_name: (threadDetail?.forum_types || [])[0]?.name || t('btn_home'),
                      product_name: device.name,
                      thread_name: threadDetail?.subject,
                      thread_tid: threadDetail?.tid,
                      account_slug: threadDetail?.author?.id,
                    }, namespace.detail);
                  }}>
                  <CommonEquipment
                    home_page={device.home_page}
                    name={device.name}
                    icon={device.icon}
                  />
              </li>)
              })
            }
          </ul> :
          <div className={Styles.empty}>{t("thread_authenticated_device_empty")}</div>
        }
      </div>
      <div className={Styles.latestPosts}>
        <div className={Styles.titleWrapper}>
          <p className={Styles.title}>{t("thread_author_threads_title")}</p>
          <Link
            href={moreHref}
            target='_blank'
            className={Styles.moreWrapper}
          >
            <span>{t("tips_thread_extend_more")}</span>
            <CommonIcon icon="more-arrow" className={Styles.moreIcon}/>
          </Link>
        </div>
          {
            author?.threads?.length > 0 ?
              <ul>
                {
                  author.threads.slice(0, 3).map(({tid, subject})=>{
                    return (
                    <li key={tid}>
                      <Link
                        href={getDetailUrl(tid)}
                        className={Styles.post}
                        target='_blank'
                        onClick={() => {
                          // 帖子入口埋点（最新帖子）
                          track?.(TRACK_EVENTS?.[namespace.detail].threadEntryClick.name, {
                            thread_tid: threadDetail?.tid,
                            thread_name: threadDetail?.subject,
                            account_slug: threadDetail?.author?.id,
                            thread_tag_name: extractThreadTags?.(threadDetail?.forum_types),
                            list_name: (threadDetail?.forum_types || [])[0]?.name || t('btn_home'),
                            click_thread_tid: tid,
                            click_thread_name: subject,
                            click_account_slug: author?.id,
                            is_featured: !!threadDetail?.digest,
                            position: 'LatestPosts',
                          }, namespace.detail);
                        }}
                      >
                      {decodeSubjectText(subject)}
                      </Link>
                    </li>
                    )
                  })
                }
              </ul> :
              <div className={Styles.empty}>{t("thread_author_threads_empty")}</div>
          }
      </div>
    </div>
  )
}

export default ThreadUser;
